import { baseNextjsUrl } from "@memorang/constants";
import type { AiAssistantInfo } from "@memorang/ui";
import { interpolateString } from "./helpers";

export const ENDPOINT_RESEND_EMAIL = `${baseNextjsUrl}/api/ai/send`;
export const ENDPOINT_RECOMMENDED_QUERIES = `${baseNextjsUrl}/api/ai/questions-beta`;
export const ENDPOINT_AIRTABLE_FEEDBACK = `${baseNextjsUrl}/api/ai/submissions`;
export const GET_SIGNED_HEADERS = `${baseNextjsUrl}/api/ai/get-signed-headers`;
export const ENDPOINT_VECTOR_STORE_DETAILS =
	"https://d7o3eqkz272osae6nfp53khxpm0dbzvl.lambda-url.us-east-1.on.aws/getVectorStoreDetails";
export const ENDPOINT_THREADS = `${baseNextjsUrl}/api/ai/threads`;
export const ENDPOINT_ASSISTANT_SESSION_REVIEW = `${baseNextjsUrl}/api/ai/assistant-session-review`;
export const RECOMMENDED_QUESTIONS_QUERY_KEY = "RECOMMENDED_QUESTIONS";
export const GET_THREAD_QUERY_KEY = "THREAD";
export const DEMO_SESSION_ANALYSIS_ENDPOINT =
	"https://staging-hub.memorang.com/api/ai/demo-report";

export const summaryActionIcons = (
	showEmail?: boolean,
	isEmailSent?: boolean,
) => [
	...(showEmail
		? [
				{
					icon: "email-outline",
					type: "email",
					tooltip: isEmailSent
						? "report.sessionAnalysis.menuActions.emailAlreadySent"
						: "report.sessionAnalysis.menuActions.emailSummary",
					disabled: isEmailSent,
				},
			]
		: []),
];

export const feedbackActionIcons = [
	{
		icon: "content-copy",
		type: "copy",
		tooltip: "report.sessionAnalysis.menuActions.copy",
	},
	{
		icon: "thumb-up-outline",
		type: "feedback-positive",
		tooltip: "report.sessionAnalysis.menuActions.positiveFeedback",
		disabled: false,
	},
	{
		icon: "thumb-down-outline",
		type: "feedback-negative",
		tooltip: "report.sessionAnalysis.menuActions.negativeFeedback",
	},
	{
		icon: "flag-outline",
		type: "report-issue",
		tooltip: "report.sessionAnalysis.menuActions.reportIssue",
	},
];

export const events = {
	copilotFeedbackSubmitted: "mem_copilot_feedback_submitted",
	copilotResponseCopyClicked: "mem_copilot_response_copy_clicked",
	sessionReportSummaryCopyClicked: "mem_session_report_summary_copy_clicked",
	sessionReportFeedbackProvided: "mem_session_report_feedback_provided",
	positiveFeedbackSubmitted: "mem_positive_feedback_submitted",
	negativeFeedbackSubmitted: "mem_negative_feedback_submitted",
	feedbackSubmitted: "mem_feedback_submitted",
	copilotFollowupSelected: "mem_copilot_followup_selected",
	searchDialogOpened: "mem_search_dialog_opened",
	copilotTextSubmitted: "mem_copilot_text_submitted",
	clearedQuery: "mem_cleared_query",
	emailTriggered: "mem_email_triggered",
	emailSent: "mem_email_sent",
	chatOpened: "mem_chat_opened",
	reportContentClicked: "mem_report_content_clicked",
};

export const searchContexts = {
	currentView: "Current View",
	currentBook: "Current Book",
	allFilteredBooks: "All Filtered Books",
} as const;

export const initialAiMessage = (
	initialMessage: string,
	context: string,
	topic: string,
	aiAssistantInfo: Omit<AiAssistantInfo, "icon">,
) =>
	interpolateString(initialMessage, {
		alias: aiAssistantInfo.alias,
		context: context ?? "your exam",
		topic,
	});
